<template>
  <div>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title>
          Participation
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-8">

          <v-simple-table class="table-border rounded">
            <template v-slot:default>
              <tbody>

              <tr>
                <td>Campagne</td>
                <td>
                  {{ raffleParticipant.raffle_campaign ? raffleParticipant.raffle_campaign.name : "-" }}
                </td>
              </tr>

              <tr class="grey lighten-3">
                <td>Superviseur</td>
                <td>
                  {{ raffleParticipant.supervisor ? raffleParticipant.supervisor.name : "-" }}
                </td>
              </tr>

              <tr>
                <td>Nom du grossiste</td>
                <td>
                  {{ raffleParticipant.wholesaler ? raffleParticipant.wholesaler.name : "-" }}
                </td>
              </tr>

              <tr class="grey lighten-3">
                <td>Code du grossiste</td>
                <td>
                  {{ raffleParticipant.wholesaler ? raffleParticipant.wholesaler.code : "-" }}
                </td>
              </tr>

              <tr>
                <td>Image</td>
                <td>
                  <div class="pa-2">
                    <v-img v-if="raffleParticipant.image"
                           :src="FILE_URL + raffleParticipant.image"
                           class="rounded zoom-pointer"
                           height="45"
                           width="45" @click="[image = [{src: FILE_URL + raffleParticipant.image}],visible = true]"/>

                    <v-img v-else :src="require('@/assets/no-image.png')"
                           class="rounded img-border"
                           height="45"
                           width="45"/>
                  </div>
                </td>
              </tr>

              <tr class="grey lighten-3">
                <td>Type de récompense</td>
                <td class="font-weight-medium blue--text">
                      <span v-if="raffleParticipant.rewarded_type">
                         {{ raffleParticipant.rewarded_type === "digital" ? "Digital" : "Physique" }}
                      </span>
                  <span v-else>-</span>
                </td>
              </tr>

              <tr>
                <td>Map</td>
                <td>
                  <div class="d-block text-no-wrap">
                    <a :href="'https://www.google.com/maps/search/?api=1&query=' + raffleParticipant.latitude + ',' + raffleParticipant.longitude"
                       class="blue--text text-decoration-none"
                       target="_blank">
                      <v-icon color="blue" dense>mdi-map-marker</v-icon>
                      {{ raffleParticipant.latitude }} - {{ raffleParticipant.longitude }}
                    </a>
                  </div>
                </td>
              </tr>

              <tr class="grey lighten-3">
                <td>Distance</td>
                <td class="font-weight-medium">
                  {{ raffleParticipant.distance }} m
                </td>
              </tr>

              <tr>
                <td>Date</td>
                <td>
                  {{ raffleParticipant.created_at }}
                </td>
              </tr>

              </tbody>
            </template>
          </v-simple-table>

        </v-card-text>
      </v-card>


      <vue-easy-lightbox :imgs="image"
                         :index="index"
                         :visible="visible"
                         escDisabled
                         moveDisabled
                         @hide="visible = false"></vue-easy-lightbox>

    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      raffleParticipant: {},

      //Show image
      image: '',
      visible: false,
      index: 0,
      FILE_URL: process.env.VUE_APP_FILE_URL
    }
  },
  methods: {
    open(raffleParticipant) {
      this.dialog = true
      this.raffleParticipant = raffleParticipant
    }
  }
}
</script>

<style scoped>

</style>